// Sesión del montacarguista logueado. Usa sessionStorage con claves propias
// (no la clave "token" del dashboard) para no pisar la sesión de Auth0 si
// alguna vez comparten el mismo navegador/dispositivo.
const KEYS = {
  token: "montacargas_token",
  userId: "montacargas_user_id",
  name: "montacargas_name",
  tarimaOptions: "montacargas_tarima_options",
  heightOptions: "montacargas_height_options",
};

export function saveLiftSession({ token, user_id, name, tarimaOptions, heightOptions } = {}) {
  sessionStorage.setItem(KEYS.token, token || "");
  sessionStorage.setItem(KEYS.userId, user_id !== undefined && user_id !== null ? String(user_id) : "");
  sessionStorage.setItem(KEYS.name, name || "");
  sessionStorage.setItem(KEYS.tarimaOptions, JSON.stringify(tarimaOptions || {}));
  sessionStorage.setItem(KEYS.heightOptions, JSON.stringify(heightOptions || {}));
}

export function getLiftToken() {
  return sessionStorage.getItem(KEYS.token) || "";
}

export function hasLiftSession() {
  return Boolean(getLiftToken());
}

const safeParse = (value) => {
  try {
    return JSON.parse(value || "{}");
  } catch (error) {
    return {};
  }
};

export function getLiftUser() {
  if (!hasLiftSession()) return null;

  return {
    userId: sessionStorage.getItem(KEYS.userId) || "",
    name: sessionStorage.getItem(KEYS.name) || "",
    tarimaOptions: safeParse(sessionStorage.getItem(KEYS.tarimaOptions)),
    heightOptions: safeParse(sessionStorage.getItem(KEYS.heightOptions)),
  };
}

export function clearLiftSession() {
  Object.values(KEYS).forEach((key) => sessionStorage.removeItem(key));
}
